import styled from "@emotion/styled"
import { BaseStyledProps, textStyles, theme, ui } from "@pallet-hq/hegel"
import {
    CardCvcElementComponent,
    CardExpiryElementComponent,
    CardNumberElementComponent,
} from "@stripe/react-stripe-js"
import { useState } from "react"

type StripeElementInputProps = {
    stripeElement:
        | CardNumberElementComponent
        | CardExpiryElementComponent
        | CardCvcElementComponent
    label: string
} & BaseStyledProps

export const StripeElementInput = ({
    stripeElement: Element,
    label,
    ...props
}: StripeElementInputProps) => {
    const [focused, setFocused] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    return (
        <ui.Wrapper {...props}>
            <ui.Label label={label} />
            <TextContainer focused={focused} error={!!errorMessage}>
                <Element
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    onChange={(event: any) => {
                        if (event.error) {
                            setErrorMessage(event.error.message)
                        } else {
                            setErrorMessage("")
                        }
                    }}
                    options={{
                        style: {
                            base: {
                                ...textStyles.paragraphLarge,
                                lineHeight: "24px",
                                "::placeholder": {
                                    color: theme.colors.gray500,
                                },
                            },
                        },
                    }}
                />
            </TextContainer>
            <ui.ErrorMessage
                showError={!!errorMessage}
                message={errorMessage}
            />
        </ui.Wrapper>
    )
}

const TextContainer = styled.div<{ focused: boolean; error: boolean }>`
    ${ui.baseStyles}
    ${props => props.error && ui.errorStyles}
    ${props => props.focused && ui.focusedStyles}
    & > * {
        width: 100%;
    }
`
